import isNil from "lodash/isNil";

const getMaxBorderRadius = ({
  borderRadius,
  containerHeight,
}: {
  borderRadius: number;
  containerHeight?: number;
}) => {
  if (isNil(containerHeight)) {
    return borderRadius;
  }

  // If the container height is less than the border radius,
  // and the border radius is not the same in all corners,
  // tamagui's border radius will not be applied correctly
  // This does not happen in the core React Native View
  // https://teamequip.atlassian.net/browse/JN-1221
  return Math.min(containerHeight / 2, borderRadius);
};

export { getMaxBorderRadius };
